var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"back_to_index",on:{"click":_vm.goToIndex}},[_c('iconList')],1)}
var staticRenderFns = []

export { render, staticRenderFns }